import styled, { css } from "styled-components/macro";
import { COLORES } from "../../constants";

export const Tr = styled.div`
  display: table-row;
  height: 1.75rem;

  background-color: ${(props) =>
    props.highlighted ? COLORES.HIGHLIGHTED : COLORES.BACKGROUND};

  :hover {
    background-color: ${COLORES.HIGHLIGHTED};
  }

  color: ${(props) => props.deleted && COLORES.DELETED};
`;

export const Td = styled.div`
  display: table-cell;
  vertical-align: middle;
  border: thin solid ${COLORES.LIGHT_BORDER};

  ${(props) =>
    props.type !== "enum" &&
    props.type !== "relate" &&
    css`      
      text-overflow: ellipsis;
      white-space: nowrap;
    `}

  a {
    margin-left: 0.45rem;
    color: ${COLORES.LINK};
    text-decoration: none;
  }
`;
